<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      :edit-config="{trigger: 'click', mode: 'row'}"
      :height="300"
      row-key
      class="sortable-row-demo"
      resizable
      border
      empty-text="暂未添加中转记录"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="add()"
            >添加中转
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            @click="$refs.table.removeCheckboxRow()"
            >删除中转
          </b-button>
        </slot>
      </template>
      <template v-slot:opt1>
        <span class="drag-btn">
          <i class="vxe-icon--menu"></i>
        </span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import Sortable from 'sortablejs'
export default {
  props: {
    dispatchOrderCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      transportModeDictParams: {type: 'transportMode'},
      bizTypeDictParams: {type: 'bizType'},
      tableData: [],
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
    }
  },
  created() {
    this.getData()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    getData() {
      if (!this.dispatchOrderCode) return
      this.rowDrop()
    },
    /**
     * 可编辑，行拖拽方法
     */
    rowDrop() {
      this.$nextTick(() => {
        const xTable = this.$refs.table
        this.sortable = Sortable.create(
          xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'),
          {
            handle: '.drag-btn',
            onEnd: ({newIndex, oldIndex}) => {
              // 获取表格临时数据
              let newTableData = xTable.getInsertRecords()
              // 清空表格临时数据
              xTable.remove(newTableData)
              // 获取当前拖拽的行
              const currRow = newTableData.splice(oldIndex, 1)[0]
              // 改变拖拽行数据位置
              newTableData.splice(newIndex, 0, currRow)
              // 重新往表格插入临时数据 -1 代表重最后一行开始插入
              newTableData.forEach((i) => {
                xTable.insertAt(i, -1)
              })
            },
          }
        )
      })
    },
    async add() {
      const $table = this.$refs.table
      const {row: newRow} = await $table.insertAt({uploadReceiptFlag: 'N'}, -1)
      await $table.setActiveCell(newRow, 'transferStationCode')
    },
    async getInsertRecords() {
      const $table = this.$refs.table
      return await $table.getInsertRecords()
    },
  },
}
</script>
<style lang="scss" scoped>
.sortable-row-demo .drag-btn {
  cursor: move;
  font-size: 12px;
}
</style>
